import { useMemo } from 'react'

interface AuthUser {
  id: string
  email: string
  role: string
}

export function useAuth() {
  const user = useMemo<AuthUser | null>(() => {
    const stored = localStorage.getItem('auth_user')
    if (!stored) return null

    try {
      const parsed = JSON.parse(stored)
      return {
        id: parsed.id,
        email: parsed.email,
        role: parsed.role,
      }
    } catch {
      return null
    }
  }, [])

  const isOrganizer = user?.role === 'Organizer' || user?.role === 'Admin' || user?.role === 'SuperAdmin'
  const isAdmin = user?.role === 'Admin' || user?.role === 'SuperAdmin'
  // WL-3: committee provisioning (create/delete/re-parent) is SuperAdmin-only. Unlike isAdmin, this
  // is the strict role — an ordinary Admin manages users + committee contact info, not structure.
  const isSuperAdmin = user?.role === 'SuperAdmin'

  return { user, isOrganizer, isAdmin, isSuperAdmin, isAuthenticated: !!user }
}
